import { FC } from 'react';

import { Skeleton } from '../Skeleton/Skeleton';
import { Stack } from '../Stack/Stack';

interface Props {
	label?: {
		width?: string;
		height?: string;
	};
	input?: {
		width?: string;
		height?: string;
	};
}

export const InputSkeleton: FC<Props> = ({ label, input }) => (
	<Stack vertical spacing="extraTight">
		<Skeleton width={label?.width ?? '100px'} height={label?.height ?? '20px'} />
		<Skeleton width={input?.width ?? '100%'} height={input?.height ?? '38px'} />
	</Stack>
);
